const actionTypes = {
  RECEIVE_COURSES_DETAILS: "seneca/course/RECEIVE_COURSES_DETAILS",
  ADD_COURSE: "seneca/course/ADD_COURSE",
  ADD_COURSE_SKELETON: "seneca/course/ADD_COURSE_SKELETON",
  ADD_SECTION: "seneca/course/ADD_SECTION",
  ADD_WORD: "seneca/course/ADD_WORD"
};

export default actionTypes;
